import getApi from "../api/getApi";
import * as url from "../api/url";

// Post Comany and Contact API
export const getContactTypes = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_CONTACT_TYPE, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
